import { render } from "./BuildingsBox.vue?vue&type=template&id=7adb388e&scoped=true&ts=true"
import script from "./BuildingsBox.vue?vue&type=script&lang=ts"
export * from "./BuildingsBox.vue?vue&type=script&lang=ts"

import "./BuildingsBox.vue?vue&type=style&index=0&id=7adb388e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adb388e"]])

export default __exports__